(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wt-ambient"] && !Shopify.designMode) return;
  try {
    (function initAmbient() {
    var KEY = 'wt-ambient';

    function setup(root) {
      var audio = root.querySelector('[data-wt-ambient-audio]');
      var toggle = root.querySelector('[data-wt-ambient-toggle]');
      var status = root.querySelector('[data-wt-ambient-status]');
      if (!audio || !toggle) return;

      // Only now is there something behind the control.
      root.hidden = false;

      function remember(state) {
        try {
          sessionStorage.setItem(KEY, state);
        } catch (e) {
          /* private mode, or storage disabled. The control still works. */
        }
      }

      function render(playing) {
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.textContent = playing
          ? toggle.getAttribute('data-label-stop')
          : toggle.getAttribute('data-label-listen');
        if (status) {
          status.textContent = playing
            ? toggle.getAttribute('data-label-stop')
            : toggle.getAttribute('data-label-listen');
        }
      }

      audio.addEventListener('play', function () {
        render(true);
      });
      audio.addEventListener('pause', function () {
        render(false);
      });

      toggle.addEventListener('click', function () {
        if (audio.paused) {
          audio.play().then(
            function () {
              remember('on');
            },
            function () {
              render(false);
            }
          );
        } else {
          audio.pause();
          remember('off');
        }
      });

      // Resume: the visitor asked for this earlier in the same tab. A browser
      // that refuses simply leaves the invitation where it was.
      var stored = null;
      try {
        stored = sessionStorage.getItem(KEY);
      } catch (e) {
        stored = null;
      }
      if (stored === 'on') {
        var attempt = audio.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {
            render(false);
          });
        }
      }
    }

    function start() {
      var roots = document.querySelectorAll('[data-wt-ambient]');
      for (var i = 0; i < roots.length; i++) setup(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-facets"] && !Shopify.designMode) return;
  try {
    /* The band applies itself.
   *
   * Everything below is enhancement: the markup is a GET form that already
   * works, and this replaces the full page load with a fetch and a swap so
   * that narrowing a catalogue does not flash the whole page.
   *
   * Listeners are delegated to the element itself, never to the controls,
   * because the panel inside it is replaced wholesale on every apply.
   */
  class WtFacets extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.debounce = null;
      this.controller = null;

      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"], select')) {
          this.apply(this.urlFromForm(), 0);
        }
      });

      /* Typing a price should not fire a request per keystroke, and the
         change event alone would leave the grid stale until blur. */
      this.addEventListener('input', (event) => {
        if (event.target.matches('input[type="number"]')) {
          this.apply(this.urlFromForm(), 500);
        }
      });

      /* Removing one filter, or clearing them all, is a link. Intercepting it
         keeps the swap consistent with every other route into this state, and
         a modified click still opens a new tab. */
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.wt-facets__tag-link, .wt-facets__clear');
        if (!link) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        this.apply(link.href, 0);
      });

      this.onPop = () => this.render(window.location.href, false);
      window.addEventListener('popstate', this.onPop);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPop);
    }

    urlFromForm() {
      const form = this.querySelector('[data-wt-form]');
      const params = new URLSearchParams();

      new FormData(form).forEach((value, key) => {
        /* An empty price field must not become `filter.v.price.gte=`, which
           reads as zero rather than as "unset". */
        if (String(value).trim() === '') return;
        params.append(key, value);
      });

      const query = params.toString();
      return query ? `${form.action}?${query}` : form.action;
    }

    apply(url, wait) {
      window.clearTimeout(this.debounce);

      /* Abort here rather than at the top of the next render. A price field is
         typed into, and the old code let a request fired at "1" come back and
         replace the panel — wiping the "8" typed while it was in flight —
         because the abort did not happen until the debounced render 500ms
         later. Cancelling on the keystroke means no stale response can ever
         land on a control the visitor is still using. */
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }

      this.debounce = window.setTimeout(() => this.render(url, true), wait);
    }

    async render(url, push) {
      const results = document.querySelector(this.dataset.target);
      const panel = this.querySelector('[data-wt-panel]');
      if (!results || !panel) return;

      const focused = this.focusKey();

      /* The server decides the disclosure's state from whether a filter is
         applied, which is right on a cold load and wrong mid-interaction:
         unticking the last box would close the panel under the hand using it.
         Whatever the visitor last set wins across a swap. */
      const narrow = this.querySelector('[data-wt-narrow]');
      const wasOpen = narrow ? narrow.open : null;

      const controller = new AbortController();
      this.controller = controller;

      results.setAttribute('data-loading', '');
      results.setAttribute('aria-busy', 'true');

      let markup;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(response.status);
        markup = await response.text();
      } catch (error) {
        /* An abort always comes from a newer apply, which has already taken
           ownership of the grid and will clear the loading state itself. */
        if (error.name === 'AbortError') return;
        /* A failed fetch falls back to the navigation the form would have
           done anyway. Better a page load than a grid that stopped answering. */
        window.location.assign(url);
        return;
      }

      /* Aborting rejects the fetch, but a response already being read can
         still resolve after a newer render has started. */
      if (this.controller !== controller) return;
      this.controller = null;

      const next = new DOMParser().parseFromString(markup, 'text/html');
      const nextPanel = next.querySelector('[data-wt-panel]');
      const nextResults = next.querySelector(this.dataset.target);

      if (nextPanel) panel.innerHTML = nextPanel.innerHTML;
      if (nextResults) results.innerHTML = nextResults.innerHTML;

      results.removeAttribute('data-loading');
      results.removeAttribute('aria-busy');

      const nextNarrow = this.querySelector('[data-wt-narrow]');
      if (nextNarrow && wasOpen !== null) nextNarrow.open = wasOpen;

      if (push) window.history.pushState({ wtFacets: true }, '', url);

      const status = this.querySelector('[data-wt-status]');
      const count = this.querySelector('.wt-facets__count');
      if (status && count) status.textContent = count.textContent.trim();

      this.restoreFocus(focused);
      this.keepInView();

      /* The swapped-in tiles carry .wt-reveal and are invisible under
         .wt-motion until something observes them. */
      document.dispatchEvent(new CustomEvent('wildtera:reveal'));
    }

    /* Narrowing twenty pieces to two shortens the page under the visitor. If
       the band has scrolled off the top by then, the grid they asked for is
       above them and what is on screen is the footer. Only ever scrolls back
       up to the controls, never away from them. */
    keepInView() {
      const top = this.getBoundingClientRect().top;
      if (top >= 0) return;

      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: window.scrollY + top - 24,
        behavior: still ? 'auto' : 'smooth',
      });
    }

    focusKey() {
      const active = document.activeElement;
      if (!active || !this.contains(active)) return null;
      return { name: active.name || '', value: active.value || '', at: active.selectionStart };
    }

    restoreFocus(key) {
      if (!key || !key.name) return;

      let selector = `[name="${CSS.escape(key.name)}"]`;
      const target =
        this.querySelector(`${selector}[value="${CSS.escape(key.value)}"]`) ||
        this.querySelector(selector);
      if (!target) return;

      target.focus();
      if (target.type === 'number' && key.at != null) {
        try {
          target.setSelectionRange(key.at, key.at);
        } catch (error) {
          /* Some browsers refuse setSelectionRange on a number input. The
             focus is the part that matters. */
        }
      }
    }
  }

  if (!customElements.get('wt-facets')) customElements.define('wt-facets', WtFacets);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-piece-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var phone = window.matchMedia('(max-width: 749px)');

    function apply() {
      var toggles = document.querySelectorAll('.wt-piece-card__record-toggle');
      for (var i = 0; i < toggles.length; i++) {
        var card = toggles[i].closest('.wt-piece-card');
        if (!card) continue;
        if (phone.matches) {
          toggles[i].hidden = false;
          if (toggles[i].getAttribute('aria-expanded') !== 'true') {
            card.classList.add('wt-piece-card--record-collapsed');
          }
        } else {
          toggles[i].hidden = true;
          card.classList.remove('wt-piece-card--record-collapsed');
        }
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest && event.target.closest('.wt-piece-card__record-toggle');
      if (!toggle) return;
      var card = toggle.closest('.wt-piece-card');
      if (!card) return;
      var open = card.classList.toggle('wt-piece-card--record-collapsed') === false;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (phone.addEventListener) phone.addEventListener('change', apply);
    document.addEventListener('DOMContentLoaded', apply);
    // The facet band swaps the results markup in place and announces it with
    // this event (snippets/wt-facets.liquid), so newly written cards get
    // collapsed too rather than arriving with the record open.
    document.addEventListener('wildtera:reveal', apply);
    apply();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-piece-filter"] && !Shopify.designMode) return;
  try {
    /* Shows and hides tiles that are already on the page.
   *
   * No fetch, no URL, no history: there is no server route to a filtered
   * metaobject page, so there is nothing to link to or navigate back through.
   * A back-navigation into this page restores the DOM from the bfcache with
   * whatever was ticked still ticked, which is what a visitor who opened a
   * piece and returned would expect anyway.
   *
   * Values are compared against `|`-delimited data attributes, so "Saree"
   * cannot match "Saree, silk" the way a bare substring test would.
   */
  class WtPieceFilter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const grid = document.querySelector(this.dataset.target);
      if (!grid) return;

      this.tiles = Array.from(grid.querySelectorAll('[data-wt-piece]'));
      this.boxes = Array.from(this.querySelectorAll('.wt-facets__box'));
      this.tags = Array.from(this.querySelectorAll('[data-wt-tag]'));
      this.active = this.querySelector('[data-wt-active]');
      this.none = this.querySelector('[data-wt-none]');
      this.count = this.querySelector('[data-wt-count]');
      this.status = this.querySelector('[data-wt-status]');
      this.summary = this.querySelector('.wt-facets__toggle');

      this.addEventListener('change', (event) => {
        if (event.target.classList.contains('wt-facets__box')) this.apply();
      });

      this.addEventListener('click', (event) => {
        const untick = event.target.closest('[data-wt-untick]');
        if (untick) {
          const key = untick.closest('[data-wt-tag]').dataset.wtTag;
          const box = this.boxes.find((candidate) => this.keyOf(candidate) === key);
          if (box) box.checked = false;
          this.apply();
          /* The button just clicked is now hidden, and focus would have landed
             on <body> — which on a long maker page means the next Tab starts
             again from the top of the document. */
          this.refocus(untick);
          return;
        }

        if (event.target.closest('[data-wt-clear]')) {
          this.boxes.forEach((box) => {
            box.checked = false;
          });
          this.apply();
          if (this.summary) this.summary.focus();
        }
      });
    }

    keyOf(box) {
      return box.dataset.wtFacet + '::' + box.value;
    }

    apply() {
      const picked = {};
      for (const box of this.boxes) {
        if (!box.checked) continue;
        if (!picked[box.dataset.wtFacet]) picked[box.dataset.wtFacet] = [];
        picked[box.dataset.wtFacet].push(box.value);
      }
      const facets = Object.keys(picked);

      let shown = 0;
      for (const tile of this.tiles) {
        /* Every facet with something ticked has to match — Type AND Fibre —
           while the values inside one facet are alternatives: saree or stole,
           in muga. */
        const keep = facets.every((facet) => {
          const held = tile.getAttribute('data-wt-' + facet) || '';
          return picked[facet].some((value) => held.includes('|' + value + '|'));
        });
        tile.hidden = !keep;
        if (keep) shown += 1;
      }

      for (const tag of this.tags) {
        const parts = tag.dataset.wtTag.split('::');
        tag.hidden = !(picked[parts[0]] || []).includes(parts[1]);
      }

      if (this.active) this.active.hidden = facets.length === 0;
      if (this.none) this.none.hidden = shown > 0;

      const template = shown === 1 ? this.dataset.countTemplateOne : this.dataset.countTemplate;
      const line = facets.length ? template.replace('{count}', shown) : this.dataset.countAll;
      if (this.count) this.count.textContent = line;
      if (this.status) this.status.textContent = line;
    }

    /* The next tag still on screen, then the last one, then the clear button,
       then the control that opens the whole band. Something in the band,
       always — and never something that is now display: none. */
    refocus(from) {
      if (document.activeElement !== document.body) return;

      const remaining = this.tags.filter((tag) => !tag.hidden);
      let next = null;
      for (const tag of remaining) {
        if (from.compareDocumentPosition(tag) & Node.DOCUMENT_POSITION_FOLLOWING) {
          next = tag;
          break;
        }
      }
      if (!next && remaining.length) next = remaining[remaining.length - 1];

      let target = null;
      if (next) target = next.querySelector('[data-wt-untick]');
      if (!target && remaining.length) target = this.querySelector('[data-wt-clear]');
      if (!target) target = this.summary;
      if (target) target.focus();
    }
  }

  if (!customElements.get('wt-piece-filter')) {
    customElements.define('wt-piece-filter', WtPieceFilter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    function setUp(root) {
      var source = root.querySelector('[data-wt-versions-data]');
      if (!source) return;
      var data;
      try {
        data = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }
      var quantityInput = document.getElementById(root.dataset.quantityInput);
      var hasChoice = !!root.querySelector('input[name="id"]');

      function chosenId() {
        var checked = root.querySelector('input[name="id"]:checked');
        if (checked) return checked.value;
        var hidden = document.querySelector('.product-variant-id');
        return hidden ? hidden.value : Object.keys(data.versions)[0];
      }

      function dispatchFor(version, quantity) {
        if (!data.tracked || quantity <= data.onHand) return version.ready;
        return data.continues ? version.made : '';
      }

      function update(fromChoice) {
        var id = chosenId();
        var version = data.versions[id];
        if (!version) return;
        var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

        document.querySelectorAll('[data-wt-dispatch]').forEach(function (el) {
          var text = dispatchFor(version, el.hasAttribute('data-wt-follows-quantity') ? quantity : 1);
          el.textContent = text;
          el.hidden = !text;
        });

        if (!hasChoice) return;

        document.querySelectorAll('.product-variant-id').forEach(function (input) {
          input.value = id;
        });
        document.querySelectorAll('[data-wt-price]').forEach(function (el) {
          el.textContent = version.price;
        });
        document.querySelectorAll('[data-wt-share]').forEach(function (el) {
          el.textContent = version.share;
          el.hidden = !version.share;
        });
        document.querySelectorAll('[data-wt-version-name]').forEach(function (el) {
          el.textContent = version.title;
        });

        if (fromChoice) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      root.addEventListener('change', function () {
        update(true);
      });
      if (quantityInput) {
        quantityInput.addEventListener('change', function () {
          update(false);
        });
        quantityInput.addEventListener('input', function () {
          update(false);
        });
      }
    }

    function start() {
      document.querySelectorAll('[data-wt-versions]').forEach(setUp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wt-video-dialog')) {
    customElements.define(
      'wt-video-dialog',
      class WtVideoDialog extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.opener = this.querySelector('.wt-video__open');
          if (!this.dialog || !this.opener) return;

          this.opener.addEventListener('click', () => this.open());
          this.querySelector('.wt-video__close').addEventListener('click', () => this.shut());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.classList.contains('wt-video__frame')) {
              this.shut();
            }
          });
          // Esc closes the dialog natively and arrives here; the two routes
          // above pause first and do not wait on this event.
          this.dialog.addEventListener('close', () => this.pauseAll());
        }

        pauseAll() {
          this.dialog.querySelectorAll('video').forEach((video) => video.pause());
        }

        shut() {
          this.pauseAll();
          this.dialog.close();
          this.opener.focus();
        }

        open() {
          // Filled in on the first open, synchronously, so play() below still
          // runs inside the press and the film may start with its sound.
          const waiting = this.dialog.querySelector('template[data-wt-video-player]');
          if (waiting) {
            waiting.replaceWith(waiting.content.cloneNode(true));
          }
          this.dialog.showModal();
          const first = this.dialog.querySelector('video');
          if (first) {
            first.play().catch(() => {});
          }
        }
      }
    );
  }

  /* The silent loop (mode: 'loop'). One controller for every loop on the page:
     one plays at a time, the most recent to come 60% into view; a loop pauses
     and holds its frame below 30% (the gap stops flicker at the edge); and a
     Pause pressed anywhere stops all of them for the rest of the visit. The
     bundle loads on every page, so nothing here runs until an element exists. */
  if (!customElements.get('wt-video-loop')) {
    const loops = new Set();
    let current = null;
    let held = false; // the contents dialog is open
    let readerPaused = false;
    try {
      readerPaused = window.sessionStorage.getItem('wt-loops') === 'paused';
    } catch (e) {
      /* storage blocked: the pause lasts for this page only */
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const reduceData = window.matchMedia('(prefers-reduced-data: reduce)');
    const connection = navigator.connection;
    const canObserve = 'IntersectionObserver' in window;
    const slowLink = () =>
      Boolean(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
    const mustWait = () => reduceMotion.matches || reduceData.matches || slowLink() || readerPaused || !canObserve;

    let loader = null;
    let watcher = null;

    const observers = () => {
      if (loader || !canObserve) return;
      // Fetch when within half a screen, so the clip is ready by the time it plays.
      loader = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            // A loop on a gallery slide that is not showing waits until it is
            // chosen; choosing it calls requestPlay, which prepares it then.
            if (entry.target.gated()) return;
            entry.target.prepare();
            loader.unobserve(entry.target);
          });
        },
        { rootMargin: '50% 0px', threshold: 0 }
      );
      watcher = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const el = entry.target;
            el.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
            if (el.ratio >= 0.6) {
              if ((!el.manual || el.userStarted) && !held && !document.hidden && !el.gated()) el.requestPlay();
            } else if (el.ratio < 0.3) {
              el.pause();
              el.userStarted = false;
            }
          });
        },
        { threshold: [0, 0.3, 0.6] }
      );
    };

    const resumeCurrent = () => {
      if (!current || held || document.hidden) return;
      if ((current.manual && !current.userStarted) || current.ratio < 0.6) return;
      current.requestPlay();
    };

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (current) current.pause();
      } else {
        resumeCurrent();
      }
    });

    // A product gallery changed slide (assets/wildtera-gallery.js). Every slide
    // sits in one box, so the observers cannot tell which is showing: the loop
    // on the slide that left pauses, and one on the slide that arrived plays if
    // the gallery is on screen and nothing is holding the loops.
    document.addEventListener('wildtera:gallery', () => {
      loops.forEach((loop) => {
        if (loop.gated()) {
          loop.pause();
          return;
        }
        if (loop.ratio >= 0.6 && (!loop.manual || loop.userStarted) && !held && !document.hidden) loop.requestPlay();
      });
    });

    // The craft page's contents dialog holds every loop while it is open.
    document.addEventListener('wildtera:loops', (event) => {
      held = Boolean(event.detail && event.detail.pause);
      if (held) {
        if (current) current.pause();
      } else {
        resumeCurrent();
      }
    });

    const onMotionChange = () => {
      if (!reduceMotion.matches) return;
      loops.forEach((loop) => {
        loop.manual = true;
        loop.userStarted = false;
        loop.pause();
      });
    };
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
    else if (reduceMotion.addListener) reduceMotion.addListener(onMotionChange);

    customElements.define(
      'wt-video-loop',
      class WtVideoLoop extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('.wt-loop__video');
          this.toggle = this.querySelector('.wt-loop__toggle');
          this.word = this.querySelector('.wt-loop__word');
          if (!this.video || !this.toggle || this.wired) return;
          try {
            this.sources = JSON.parse(this.dataset.sources || '[]').filter((s) => s && s.u);
          } catch (e) {
            this.sources = [];
          }
          // No rendition to play: the poster stands as a still, with no control.
          if (!this.sources.length) return;

          this.wired = true;
          this.manual = mustWait();
          this.userStarted = false;
          this.ratio = 0;
          this.errors = 0;
          this.started = false;
          this.video.muted = true;

          this.toggle.hidden = false;
          this.toggle.addEventListener('click', () => this.onToggle());
          this.video.addEventListener('playing', () => {
            this.classList.add('is-playing');
            this.render();
          });
          this.video.addEventListener('pause', () => this.render());
          this.video.addEventListener('error', () => this.onError());

          loops.add(this);
          observers();
          if (watcher) watcher.observe(this);
          if (loader && !this.manual) loader.observe(this);
          this.render();
        }

        disconnectedCallback() {
          loops.delete(this);
          if (loader) loader.unobserve(this);
          if (watcher) watcher.unobserve(this);
          this.pause();
          if (current === this) current = null;
          this.wired = false;
        }

        // True while this loop sits on a gallery slide that is not the one showing.
        gated() {
          const slide = this.closest('[data-gallery-slide]');
          return Boolean(slide && !slide.classList.contains('is-active'));
        }

        // The largest rendition no taller than the target, or the smallest there is.
        pick() {
          const narrow = window.innerWidth < 750 || (connection && connection.effectiveType === '3g');
          const target = narrow ? 480 : parseInt(this.dataset.max, 10) || 720;
          const sorted = this.sources.slice().sort((a, b) => a.h - b.h);
          const fits = sorted.filter((s) => s.h <= target);
          return fits.length ? fits[fits.length - 1] : sorted[0];
        }

        prepare() {
          if (this.prepared) return;
          this.prepared = true;
          this.video.preload = 'auto';
          this.video.src = this.pick().u;
          this.video.load();
        }

        // Resolves once the poster's unveil has finished, so the clip never
        // fades in over a half-uncovered photograph.
        settled() {
          if (this.settling) return this.settling;
          const unveil = this.closest('.wt-unveil');
          if (!unveil || !document.documentElement.classList.contains('wt-motion')) {
            this.settling = Promise.resolve();
            return this.settling;
          }
          this.settling = new Promise((resolve) => {
            const img = this.querySelector('.wt-media img');
            const afterReveal = () => {
              if (!img) return resolve();
              const still = getComputedStyle(img).transform;
              if (still === 'none' || still === 'matrix(1, 0, 0, 1, 0, 0)') return resolve();
              const fallback = window.setTimeout(resolve, 1600);
              img.addEventListener('transitionend', function done(event) {
                if (event.propertyName !== 'transform') return;
                img.removeEventListener('transitionend', done);
                window.clearTimeout(fallback);
                resolve();
              });
            };
            if (unveil.classList.contains('is-in')) {
              afterReveal();
            } else {
              const watch = new MutationObserver(() => {
                if (!unveil.classList.contains('is-in')) return;
                watch.disconnect();
                afterReveal();
              });
              watch.observe(unveil, { attributes: true, attributeFilter: ['class'] });
            }
          });
          return this.settling;
        }

        // The first play starts on the poster's own frame.
        seekToPoster() {
          const offset = parseFloat(this.dataset.posterOffset) || 0;
          if (offset <= 0) return Promise.resolve();
          return new Promise((resolve) => {
            const fallback = window.setTimeout(resolve, 2500);
            const seek = () => {
              this.video.addEventListener(
                'seeked',
                () => {
                  window.clearTimeout(fallback);
                  resolve();
                },
                { once: true }
              );
              this.video.currentTime = offset;
            };
            if (this.video.readyState >= 1) seek();
            else this.video.addEventListener('loadedmetadata', seek, { once: true });
          });
        }

        async requestPlay() {
          if (this.gated()) return;
          if (current && current !== this) current.pause();
          current = this;
          this.prepare();
          await this.settled();
          if (current !== this) return;
          if (!this.started) {
            this.started = true;
            await this.seekToPoster();
            if (current !== this) return;
          }
          try {
            await this.video.play();
          } catch (e) {
            // Refused (iOS Low Power Mode, an autoplay policy): a still with Play.
            this.manual = true;
            this.userStarted = false;
            this.render();
          }
        }

        pause() {
          if (this.video && !this.video.paused) this.video.pause();
        }

        render() {
          const playing = !this.video.paused && !this.video.ended;
          this.toggle.classList.toggle('is-paused', !playing);
          this.word.textContent = playing ? this.dataset.pause : this.dataset.play;
        }

        onToggle() {
          if (!this.video.paused) {
            this.pause();
            this.userStarted = false;
            readerPaused = true;
            try {
              window.sessionStorage.setItem('wt-loops', 'paused');
            } catch (e) {
              /* the pause still holds for this page */
            }
            loops.forEach((loop) => {
              loop.manual = true;
            });
          } else {
            // The reader's own press: allowed under reduced motion and Save-Data.
            this.userStarted = true;
            this.requestPlay();
          }
        }

        onError() {
          this.errors += 1;
          this.classList.remove('is-playing');
          this.prepared = false;
          this.manual = true;
          this.userStarted = false;
          if (this.errors >= 2) this.toggle.hidden = true;
          this.render();
        }
      }
    );
  }

  /* The reel (mode: 'reel'): a film with sound that plays where it sits, only
     when pressed. The chip covers the poster until then; once the film plays
     the browser's own controls take over, and the chip returns at the end.
     Scrolled out of view it pauses, so a voice never carries on from a part
     of the page the reader has left. One reel plays at a time. */
  if (!customElements.get('wt-video-reel')) {
    const reelWatcher =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) entry.target.pause();
              });
            },
            { threshold: 0 }
          )
        : null;

    customElements.define(
      'wt-video-reel',
      class WtVideoReel extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.wt-reel__play');
          if (!this.video || !this.button) return;

          // The browser's control bar would sit under the chip until the
          // first press, two controls for one action, so it waits. It stays
          // in the markup for a visitor without JavaScript.
          this.video.controls = false;
          this.button.hidden = false;
          this.button.addEventListener('click', () => {
            this.showChip(false);
            this.video.play().catch(() => this.showChip(true));
            this.video.focus({ preventScroll: true });
          });
          this.video.addEventListener('play', () => {
            this.showChip(false);
            document.querySelectorAll('wt-video-reel').forEach((other) => {
              if (other !== this) other.pause();
            });
          });
          this.video.addEventListener('ended', () => this.showChip(true));
          if (reelWatcher) reelWatcher.observe(this);
        }

        disconnectedCallback() {
          if (reelWatcher) reelWatcher.unobserve(this);
        }

        showChip(show) {
          this.button.hidden = !show;
          this.video.controls = !show;
        }

        pause() {
          if (this.video && !this.video.paused) this.video.pause();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
